import { render, staticRenderFns } from "./EditUserProfile.view.vue?vue&type=template&id=2b461f31&scoped=true&"
import script from "./EditUserProfile.view.vue?vue&type=script&lang=js&"
export * from "./EditUserProfile.view.vue?vue&type=script&lang=js&"
import style0 from "./EditUserProfile.view.vue?vue&type=style&index=0&id=2b461f31&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b461f31",
  null
  
)

export default component.exports